import { EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { FlightService } from 'src/app/services/flight.service';
import { InsuranceService } from 'src/app/services/insurance.service';


import { DataService } from 'src/app/services/data.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SettingsService } from '../../../services/settings.service';
import { ColorsService } from 'src/app/services/colors.service';
import * as XLSX from "xlsx";
import * as ExcelJS from 'exceljs';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';

import { DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialogConfig } from '@angular/material/dialog';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { Pipe, PipeTransform } from '@angular/core';
import { AirConfigService } from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatTabGroup } from '@angular/material/tabs';
import jwt_decode from 'jwt-decode';
import { TripService } from 'src/app/services/trip.service'
import { MatButtonToggleGroup } from '@angular/material/button-toggle';

@Component({
  selector: 'app-insurance-list',
  templateUrl: './insurance-list.component.html',
  styleUrls: ['./insurance-list.component.css']
})
export class InsuranceListComponent implements OnInit {

    showSidebar: boolean = false
    pointerEvents:boolean=false
  
  
    username: any
    color: any
    parentType: any
    countdown: number = 600;
  interval: any;
  messageData: any;
  userUuid: any
  userType: any

  
    constructor(private DialogService:DialogService,private UserService: UserService, private TripService: TripService, private UserprofileService: UserprofileService, private SettingsService: SettingsService, private toastMsgService: ToastmsgService, private fb: FormBuilder, private FlightService: FlightService,private InsuranceService:InsuranceService, private route: ActivatedRoute
      , private router: Router, private data: DataService, private AirConfigService: AirConfigService, private userInfoService: UserInfoService, private cdr: ChangeDetectorRef, private ColorsService: ColorsService) {
      
      let ite: string = userInfoService.getParentUser() || ''
      if (ite) {
        let token: any = jwt_decode(ite)
        if (token) {
          this.parentType = token?.type
  
  
        }
      }
  
      this.username = userInfoService.getUsername();
      this.ColorsService.colors("", "").then((color: any) => {
        this.color = color
      })
        .catch((error: any) => {
        });
      this.userType = this.userInfoService.getUserType()
      this.userType = this.userType.toUpperCase()
  
      this.userUuid = this.userInfoService.getUserUuid()
  
      // console.log(this.userUuid)
  
 
      this.route.queryParams.subscribe(params => {
        let data: any
        data = params
  
      });
      this.data.portMessage.subscribe((message: any) => this.messageData = message)
  
      this.data.deliverMsg(this.messageData)
  
    
  
      if (this.messageData === "default message") {
        this.router.navigate(["/app/insurance"]);

      } else {
       
        this.searchFlight()
  
      }
  
     
    }
  
    ngOnInit(): void {
  
    }
   
  
  
   
    showPending:boolean=false
    blankList:boolean=false
    visibleflights:any=[]
    insuranceDataList:any=[]
    insurancePlansList:any=[]

    displayedColumns: any[] = [];
  columnsDisplay=this.displayedColumns
  columnHeaderMap: { [key: string]: string } = {};

    searchFlight() {
       this.blankList=false
  
  this.insuranceDataList=[]
      setTimeout(() => {
        this.showPending = false
  
      }, 20 * 60 * 1000);
   
      this.showPending = true
     
      let request = JSON.parse(JSON.stringify(this.messageData))
      delete request.uuid;
     
      this.InsuranceService.SearchFlight(request)
        .subscribe({
          next: (res) => {
            this.showPending = false

            // console.log(res)
            let data: any
            data = res.body
            if(data){
            this.insuranceDataList=data?.plansCoverages||[]
          this.insurancePlansList=data?.plans||[]
            //  const planPremiumMap: { [key: string]: number } = {};

  // Collect unique plan types and their premiums
  // data.plans.forEach((plan: any) => {
  //   planTypesSet.add(plan.planType);
  //   const person = plan.persons[0]; // assuming one person per plan
  //   if (person) {
  //     planPremiumMap[plan.planType] = person.totalPremium;
  //   }
  // });

let planPremiumMap:any=[{
  check:'',"refNo":'', "name":'Premium Amount', "coverageType":'',"deductible":'',"siOption":'',plans:data.plans
}]
 this.insuranceDataList=[...planPremiumMap,...data.plansCoverages]
console.log(this.insuranceDataList)

            const baseCols = ['refNo', 'name', 'coverageType'];
            const planTypesSet = new Set<string>();
          
            // this.insuranceDataList.forEach((row:any) => {
              data.plans.forEach((plan:any) => {
                planTypesSet.add(plan?.planType);
              });
            // });
            // Map column keys to planType names
            let index = 0;
            const planCols: string[] = [];
            planTypesSet.forEach((planType:any) => {
              const key = `planType_${index++}`;
              this.columnHeaderMap[key] = planType;
              planCols.push(key);
            });
          
            this.displayedColumns = [...baseCols, ...planCols,'deductible','siOption'];




            // this.displayedColumns = [...baseCols, ...planCols,'deductible','siOption'];




this.columnsDisplay=this.displayedColumns
            }


  
  
         
  
          }, error: (err) => {
            this.blankList=true
  
            this.showPending = false
  
            //this.router.navigate(["/app/flight"]);
            // this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });
  
          }
        }
        )
    }
  
    

//   getSumInsuredByPlanType(element: any, col: string): number | string {
//     const planType = this.columnHeaderMap[col];
//     console.log('3')

//     if (!element?.plans || !planType || !element?.name) return '-';
// console.log(planType)
//     const matchingPlan = element.plans.find(
//       (plan: any) => plan.planType === planType 
//     );

// let matchData:any='-'
//       console.log(matchingPlan)

//     if (!('coverageValue' in matchingPlan)) {
//       console.log('1')
//       // The key doesn't exist
//       matchData='matchingPlan.plans'
//     }else{
//       console.log('3')

//       matchData= matchingPlan?.coverageValue ?? '-'
//     }
    
//     return matchData;
//     // totalPremium
//     // totalPremiumAmount
//   }
getSumInsuredByPlanType(element: any, col: string): number | string {
  const planType = this.columnHeaderMap[col];
  // console.log('Plan Type:', planType);
// console.log(planType)
  if (!element?.plans || !planType) {
    // console.log('Missing required data (plans, planType, or name)');
    return '-';
  }

  const matchingPlan = element?.plans?.find((plan: any) => plan.planType === planType);
  // console.log('Matching Plan:', matchingPlan);

//   if (!matchingPlan || !('coverageValue' in matchingPlan)) {
//     console.log('coverageValue not found in matching plan');
//     let output = '';
// let total = 0;
//     matchingPlan.persons.forEach((p:any, index:any) => {
//       output += `Person ${index + 1}: ${matchingPlan.totalPremiumAmount} | `;
//       total += p.totalPremium;
//     });
    
//     output += `Total Sum = ${total.toFixed(2)}`;
//     return output;
//   }
if (!matchingPlan || !('coverageValue' in matchingPlan)) {
  // console.log('coverageValue not found in matching plan');

  let headerRow = '';
  let valueRow = '';
  let total = 0;

  matchingPlan.persons.forEach((p: any, index: number) => {
    if( matchingPlan.persons.length!=1){

    headerRow += `<th>Person&nbsp;${index + 1}</th>`;}
    valueRow += `<td>${p.totalPremium?.toFixed()}</td>`;
    total = matchingPlan.totalPremiumAmount?.toFixed();
  });
  // console.log(matchingPlan.persons.length)
if( matchingPlan.persons.length!=1){
  headerRow += `<th><strong>Total</strong></th>`;
  valueRow += `<td><strong>${total}</strong></td>`;

  
const style = document.createElement('style');
style.innerHTML = `
  
table th, table td {
  border: 2px solid #E0D2D1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 8px;
  text-align: start;
}

table th {
  background-color: #DDEAF6;
  border-collapse:separate
}

table tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

`;
document.head.appendChild(style);
}
  const tableHTML = `
    <table class="custom-table">
      <tr style="font-weight: bold; border: 1px solid #ccc;">
        ${headerRow}
      </tr>
      <tr style="border: 1px solid #ccc;">
        ${valueRow}
      </tr>
    </table>
  `;

  return tableHTML;

}


  const matchData = matchingPlan.coverageValue ?? '-';
  // console.log('Coverage Value:', matchData);

  return matchData;
}
stickyColumns = [0, 1, 7, 8];

stickyColumn = [0, 1,2, 7, 8];





generateBookingInsurance(item:any){
  console.log(this.insurancePlansList)
let element:any=  this.insurancePlansList.filter((items:any)=>items.planType===item)
console.log(element)
if(element.length!=0){
  element=element[0]

}
  // console.log(item)
  let request:any={
      "channel": "WEB",
      "insuranceRequest": this.messageData,
       "planName":element.planName,
       "insurancePlanSearchResponse":element
  }
  this.InsuranceService.generateBookingInsurance(request)
  .subscribe({
    next : (res) => {
      if(res) {
        let data: any
        data = res?.body
        if(data){
        let url = "/app/insurance-book?id=" + this.SettingsService.transform(data?.orderNumber)
        window.open(url); 
        }else{
          this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });

        }
              
      } else {
        this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });
      } 

    },error : (err) => {
      this.toastMsgService.setMsg({ msg: "Unable to book; please try later !", msgTitle: "Warning", msgType: "W" });

    }
  }
)
}

}
